export const DETECTION_QUERIES_INJECTION_KEY = Symbol(
	"DETECTION_QUERIES_INJECTION_KEY",
);
export const FILTERS_INJECTION_KEY = Symbol("FILTERS_INJECTION_KEY");
